import { render } from "./PunishmentTransactionDetail.vue?vue&type=template&id=6f212e54"
import script from "./PunishmentTransactionDetail.vue?vue&type=script&lang=js"
export * from "./PunishmentTransactionDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__